import { useSelectorNonNullable, useSelector } from 'src/hooks/useSelector';

export const useVacancyIdNonNullable = (): number => {
    const fromSearch = useSelectorNonNullable((state) => state.resumeSearchResult.criteria?.vacancy_id);
    const fromResponses = useSelectorNonNullable((state) => state.vacanciesShort.vacanciesList?.[0]?.vacancyId);

    return fromSearch || fromResponses;
};

const useVacancyId = (): number | undefined => {
    const fromSearch = useSelector((state) => state.resumeSearchResult.criteria?.vacancy_id);
    const fromResponses = useSelector((state) => state.vacanciesShort.vacanciesList?.[0]?.vacancyId);

    return fromSearch || fromResponses;
};

export default useVacancyId;
